import React, { useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import '../css/Sidebar.css';

const FALLBACK_ITEMS = [
  { slug: "murasaki", title: "明度の記録-2025-08-24" },
  { slug: "mint", title: "薄荷-2025-08-11" },
  { slug: "202503", title: "Марта-2025-03" },
  { slug: "202502", title: "февраля-2025-02" },
  { slug: "202501", title: "Январь-2025-01" },
  { slug: "202410", title: "Октябрь-2024-10" },
];

function Sidebar({ sidebarVisible, toggleSidebar }) {

  const sidebarRef = useRef(null);
  const [items, setItems] = React.useState(FALLBACK_ITEMS);

  // --- スライド表示の制御（旧仕様と同じ動き） ---
  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (!sidebar) return;

    sidebar.style.right = sidebarVisible ? '8px' : '-280px';
  }, [sidebarVisible]);

  // --- 外側クリックで閉じる ---
  useEffect(() => {
    const handleOutside = (e) => {
      const sidebar = sidebarRef.current;
      if (!sidebarVisible) return;
      if (sidebar && !sidebar.contains(e.target)) {
        toggleSidebar(false);
      }
    };

    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [sidebarVisible, toggleSidebar]);

  useEffect(() => {
    let active = true;

    const loadIndex = async () => {
      try {
        const res = await fetch("/api/archive-index.json");
        if (!res.ok) throw new Error(`index fetch failed: ${res.status}`);
        const data = await res.json();
        if (!active) return;

        const dynamicItems = Array.isArray(data.items)
          ? data.items.map((item) => ({
              slug: item.slug,
              title: `${item.title}-${String(item.publishedAt || "").slice(0, 10)}`,
            }))
          : [];

        if (dynamicItems.length > 0) {
          setItems(dynamicItems);
        } else {
          setItems(FALLBACK_ITEMS);
        }
      } catch (_) {
        if (active) setItems(FALLBACK_ITEMS);
      }
    };

    loadIndex();

    return () => {
      active = false;
    };
  }, []);

  return (
    <div id="sidebar" ref={sidebarRef} className="sidebar">

      <button
        id="close-sidebar"
        className="close-sidebar"
        onClick={() => toggleSidebar(false)}
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>

      <ul>
        {items.map((item) => (
          <li key={item.slug}>
            <Link to={`/archive/${item.slug}`} onClick={() => toggleSidebar(false)}>
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
